import "./Faq.module.css";
import Header from "@/reusable_sections/Header";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GetAFreeEstimateCta from "./sections/GetAFreeEstimateCta";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import Footer from "@/reusable_sections/Footer";
export default function FaqPage() {
  return <div>
      <Header />
      <FrequentlyAskedQuestions />
      <GetAFreeEstimateCta />
      <CustomerTestimonials />
      <Footer />
    </div>;
}